/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <LoadScreen v-if="mostrarLoader"></LoadScreen>

    <ModalBase v-if="mostrarModal">
        <section class="contenedorPrincipal">
            <section>
                <div class="titulo">{{ tituloHeader }}</div>
                <div class="separador"></div>
            </section>

            <div class="form-group">
                <div class="label">Nombre:</div>
                <input class="inputEditar" type="text" maxlength="50" v-model="nombre" @input="validarNombre"
                    placeholder="Nombre completo" />
            </div>

            <div class="form-group">
                <div class="label">Selecciona un estado:</div>
                <select class="inputEditar" id="estado" name="estado" required v-model="estadoSeleccionado"
                    @change="llenarCiudades">
                    <option value="">-- Seleccione un estado --</option>
                    <option v-for="estado in estadosDisponibles" :key="estado.nombre" :value="estado.nombre">
                        {{ estado.nombre }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <div class="label">Selecciona una ciudad:</div>
                <select class="inputEditar" id="ciudad" name="ciudad" required v-model="ciudadSeleccionada"
                    :disabled="!ciudadesDisponibles.length">
                    <option value="">-- Primero selecciona un estado --</option>
                    <option v-for="ciudad in ciudadesDisponibles" :key="ciudad" :value="ciudad">
                        {{ ciudad }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <div class="label">Domicilio</div>
                <input class="inputEditar" type="text" maxlength="100" v-model="domicilio"
                    placeholder="Calle, número y colonia" />
            </div>

            <div class="form-group">
                <div class="label">Teléfono</div>
                <input class="inputEditar" type="text" maxlength="10" v-model="telefono" @input="validarTelefono"
                    placeholder="Ingrese 10 dígitos" />
            </div>

            <div class="form-group">
                <div class="label">Rol:</div>
                <select class="inputEditar" v-model="rol">
                    <option value="1">Administrador</option>
                    <option value="2">Instalador</option>
                </select>
            </div>

            <div class="form-group">
                <div class="label">Correo:</div>
                <input class="inputEditar" type="email" maxlength="50" v-model="correo"
                    placeholder="ejemplo@correo.com" />
            </div>

            <div class="form-group">
                <div class="label">Contraseña:</div>
                <input class="inputEditar" type="password" v-model="clave" placeholder="Mínimo 8 caracteres" />
            </div>

            <section class="contenedorBotones">
                <Button class="btn-regresar" @click="cancelar">Regresar</Button>
                <Button class="btn-guardar" @click="registrarAdministrador">Guardar</Button>
            </section>
        </section>

        <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito" />

        <ModalError v-if="mostrarError" :mensajeExito="mensajeError" @cerrar="mostrarError = false" />
    </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import ModalExito from "../Modales/ModalExito.vue";
import ModalError from "../Modales/ModalError.vue";
import LoadScreen from '../Forms/LoadScreen.vue';
import userService from '@/services/userService';

import estadosData from '../../data/estados_municipios.json';

export default {
    components: { Button, ModalBase, ModalExito, ModalError, LoadScreen },
    props: {
        tituloHeader: { type: String, default: "Agregar Administrador" },
    },
    data() {
        return {
            estadosDisponibles: estadosData.estados,
            ciudadesDisponibles: [],
            estadoSeleccionado: '',
            ciudadSeleccionada: '',
            mostrarLoader: false,
            mostrarModal: true,
            mostrarExito: false,
            mostrarError: false,
            mensajeError: '',
            nombre: '',
            domicilio: '',
            telefono: '',
            correo: '',
            clave: '',
            rol: '1',
        };
    },
    emits: ["cancelar", "actualizado"],
    methods: {
        llenarCiudades() {
            this.ciudadSeleccionada = '';
            const nombreEstado = this.estadoSeleccionado;
            const estadoEncontrado = this.estadosDisponibles.find(e => e.nombre === nombreEstado);
            this.ciudadesDisponibles = estadoEncontrado ? estadoEncontrado.municipios.map(m => m.nombre) : [];
        },

        cancelar() { this.$emit("cancelar"); },

        validarNombre() {
            this.nombre = this.nombre.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
        },

        validarTelefono() {
            this.telefono = this.telefono.replace(/[^0-9]/g, '');
        },
        esEmailValido(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },

        async registrarAdministrador() {
            if (!this.nombre || !this.correo || !this.clave || !this.estadoSeleccionado || !this.ciudadSeleccionada) {
                this.lanzarError("Todos los campos son obligatorios.");
                return;
            }

            if (!this.esEmailValido(this.correo)) {
                this.lanzarError("Por favor, ingresa un correo electrónico válido (ejemplo@dominio.com).");
                return;
            }

            if (this.clave.length < 8) {
                this.lanzarError("La contraseña debe tener al menos 8 caracteres.");
                return;
            }

            const names = this.splitName(this.nombre);
            if (!names.ape_pat || !names.ape_mat) {
                this.lanzarError("Por favor, ingrese el nombre completo (Nombre y dos Apellidos).");
                return;
            }

            this.mostrarLoader = true;

            const adminData = {
                nombre: names.nombre,
                ape_pat: names.ape_pat,
                ape_mat: names.ape_mat,
                correo: this.correo,
                contraseña: this.clave,
                telefono: this.telefono,
                domicilio: this.domicilio,
                estado: this.estadoSeleccionado,
                ciudad: this.ciudadSeleccionada,
                id_rol: parseInt(this.rol),
            };

            try {
                await userService.createUser(adminData);
                this.mostrarLoader = false;
                this.mostrarExito = true;
                setTimeout(() => {
                    this.$emit("actualizado");
                    this.cancelar();
                }, 1500);
            } catch (error) {
                this.mostrarLoader = false;
                if (error.response && error.response.status === 400) {
                    const errores = error.response.data;
                    this.mensajeError = errores.correo ? "Este correo ya está registrado." : "Datos incorrectos. Revisa el formulario.";
                } else {
                    this.mensajeError = "Error interno del servidor.";
                }
                this.mostrarError = true;
                this.autoCerrarError();
            }
        },

        lanzarError(msj) {
            this.mensajeError = msj;
            this.mostrarError = true;
            this.autoCerrarError();
        },

        autoCerrarError() {
            setTimeout(() => { this.mostrarError = false; }, 3000);
        },

        splitName(fullName) {
            const parts = fullName.trim().split(/\s+/);
            let nombre = '', ape_pat = '', ape_mat = '';
            if (parts.length === 1) { nombre = parts[0]; }
            else if (parts.length === 2) { nombre = parts[0]; ape_pat = parts[1]; }
            else if (parts.length >= 3) {
                ape_mat = parts.pop();
                ape_pat = parts.pop();
                nombre = parts.join(' ');
            }
            return { nombre, ape_pat, ape_mat };
        },
    },
};
</script>

<style scoped>
.contenedorPrincipal {
    margin: 0px 30px;
    padding-bottom: 20px;
}

.titulo {
    padding: 30px 0px 10px 0px;
    font-size: 28px;
    font-weight: 600;
    color: #333;
}

.separador {
    border-top: 3px solid #2a428c;
    margin-bottom: 25px;
}

.form-group {
    margin-bottom: 15px;
}

.label {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 14px;
    color: #444;
}

.inputEditar {
    width: 100%;
    max-width: 350px;
    height: 38px;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0px 10px;
    box-sizing: border-box;
}

.inputEditar:focus {
    outline: none;
    border-color: #29b9f6;
    box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.contenedorBotones {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 35px;
}

@media (max-width: 768px) {
    .inputEditar {
        max-width: 100%;
        height: 42px;
        font-size: 16px;
    }
}
</style>